import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
// import axiosInstance from "@/axios/axiosInstance";
import "./BankCard.scss";

const BankCard = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    // 导航到确认页面，并传递表单数据
    navigate("/personal/finance/bankcard/confirm", {
      state: { bankInfo: values },
    });
  };

  return (
    <div className="bank-card-container">
      <div className="title">提现余额至银行卡</div>
      <div className="account-info">
        <div className="info-item">账户：133****33</div>
        <div className="info-item">
          可提现余额（元）：<span className="amount">1280.50</span>
        </div>
      </div>

      <div className="bind-card-section">
        <div className="section-title">添加提现银行卡</div>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="bank-form"
        >
          <Form.Item
            label="城市开户行"
            name="bankName"
            rules={[{ required: true, message: "请输入开户行" }]}
          >
            <Input placeholder="中国银行" />
          </Form.Item>

          <Form.Item
            label="请填开户行网点"
            name="branchName"
            rules={[{ required: true, message: "请输入开户行网点" }]}
          >
            <Input placeholder="中国银行北京西四支行" />
          </Form.Item>

          <Form.Item
            label="提现银行卡号"
            name="cardNumber"
            rules={[
              { required: true, message: "请输入银行卡号" },
              { pattern: /^\d{16,19}$/, message: "请输入正确的银行卡号" },
            ]}
          >
            <Input placeholder="621669010000835****" />
          </Form.Item>

          <Form.Item
            label="银行开户人姓名"
            name="holderName"
            rules={[{ required: true, message: "请输入持卡人姓名" }]}
          >
            <div className="holder-name-section">
              <Input placeholder="程舒扬" />
              <div className="name-notice">
                请务必填写与银行开户时一致的姓名，否则提现失败
              </div>
            </div>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="submit-btn"
            >
              下一步
            </Button>
          </Form.Item>
        </Form>
      </div>

      <div className="notice-section">
        <div className="notice-title">
          <span className="icon">🔔</span> 温馨提示：
        </div>
        <ol>
          <li>
            提现时请确保银行卡<span className="highlight">50元</span>
            以上方可提现
          </li>
          <li>提现时请确保银行卡处于正常状态，如遇到提现失败，请联系客服</li>
          <li>为确保资金安全，请务必填写本人银行卡，切勿填写他人银行卡</li>
          <li>如遇到问题，请联系客服处理</li>
          <li>
            一般情况下，请确保提现银行卡为储蓄卡，提现到信用卡可能导致提现失败
          </li>
        </ol>
      </div>
    </div>
  );
};

export default BankCard;
